import { render, staticRenderFns } from "./ed-switch.vue?vue&type=template&id=1484f351&"
import script from "./ed-switch.ts?vue&type=script&lang=ts&"
export * from "./ed-switch.ts?vue&type=script&lang=ts&"
import style0 from "./ed-switch.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports